import { Link, Tooltip, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { CustomerEntry } from '../../sdk'
import { formatName } from '../../utils/formatCustomerName/formatCustomerName'

export const CustomerLinkWithNotes = ({
  customer
}: {
  customer: CustomerEntry
}) => {
  return (
    <Link component={RouterLink} to={AppRoutes.CUSTOMERS + '/' + customer.id}>
      <Tooltip title={customer.information!.notes || ''} arrow>
        <Typography>{formatName(customer.information)}</Typography>
      </Tooltip>
    </Link>
  )
}
